/* eslint-disable no-nested-ternary */
import { Grid, TextareaAutosize } from '@material-ui/core';
import {
  Block,
  Business,
  CheckBox,
  DateRange,
  Description as DescriptionIcon,
  Euro as EuroIcon,
  LocationOn as LocationOnIcon,
  EventAvailable,
  Favorite,
  FavoriteBorder,
  Gesture,
  Home,
  Language as LanguageIcon,
  MenuBookRounded,
  Schedule,
  SchoolRounded as SchoolIcon,
  SettingsBackupRestore as SettingsBackupRestoreIcon,
  VerifiedUser as VerifiedUserIcon,
  WatchLater as WatchLaterIcon,
  Loop as LoopIcon,
} from '@material-ui/icons';
import {
  checkIfPostuleTraining,
  checkIfSavedTraining,
  postuleTraining,
  savedTraining,
  unSavedTraining,
} from '@webapps/business';
import {
  Button,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import GradeIcon from 'components/Icons/GradeIcon';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import parse from 'html-react-parser'
import HourglassHalf from 'components/Icons/HourglassHalf';
import ListChecked from 'components/Icons/ListChecked';
import theme from 'pages/MyMap/theme';

const {
  colors: { background },
} = theme;

const DetailsFormation = ({ info = {} }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { profile } = useAuth();

  const { idUser } = useAuth();

  const { addToast } = useToast();

  const {
    isLoading: isLoadingSavedTraining,
    isSuccess: isSuccessSave,
    mutateAsync: mutateSavedTraining,
  } = useMutation(savedTraining);

  const {
    isLoading: isLoadingPostuleTraining,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleTraining,
  } = useMutation(postuleTraining);

  const {
    isLoading: isLoadingUnSavedTraining,
    isSuccess: isSuccessUnSave,
    mutateAsync: mutateUnSavedTraining,
  } = useMutation(unSavedTraining);

  const { data: checkSave = {}, refetch } = useQuery(checkIfSavedTraining, {
    key: ['checkSavedTraining'] + idUser + info?.id,
    variables: { idApplicant: idUser, idTraining: info?.id },
  });

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleTraining,
    {
      key: ['checkPostuleTraining'] + idUser + info?.id,
      variables: { idApplicant: idUser, idTraining: info?.id },
    }
  );

  useEffect(() => {
    if (isSuccessSave) {
      addToast({
        status: 'success',
        message: 'Formation sauvegardé',
      });
    }
    refetch();
  }, [isSuccessSave]);

  useEffect(() => {
    if (isSuccessPostule) {
      addToast({
        status: 'success',
        message: 'Vous avez postulé à la formation',
      });
    }
    refetchPostule();
  }, [isSuccessPostule]);

  useEffect(() => {
    if (isSuccessUnSave) {
      addToast({
        status: 'success',
        message: 'Formation retirée des sauvegardes',
      });
    }
    refetch();
  }, [isSuccessUnSave]);

  const saveTraining = async () => {
    await mutateSavedTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: info?.id,
        },
      },
    });
  };

  const postuTraining = async () => {
    await mutatePostuleTraining({
      data: {
        applicant: {
          id: idUser,
        },
        training: {
          id: info?.id,
        },
      },
    });
  };

  const unSaveTraining = async () => {
    await mutateUnSavedTraining({
      idApplicant: idUser,
      idTraining: info?.id,
    });
  };

  const date = new Date();

  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}><p style={{ margin: 0 }}>Informations pratiques:</p></div>
      <div style={{ marginBottom: '20px' }}>
        <Grid container>
          <Grid item >
            <div className={classes.info}>
              <SchoolIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="levelDiplome" /> :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.degree?.label}
              </div>
            </div>
            <div className={classes.info}>
              <LocationOnIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Adresse :
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.address?.label}
              </div>
            </div>
            <div className={classes.info}>
              <MenuBookRounded className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Domaine d'étude:{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.domain?.label}
              </div>
            </div>
            <div className={classes.info}>
              <DescriptionIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="typeContrate" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.trainingType?.label}
              </div>
            </div>
            <div className={classes.info}>
              <EuroIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="fraisInscription" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.programCost} €
              </div>
            </div>
            <div className={classes.info}>
              <EuroIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="fraisScolarite" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.registrationFees} €
              </div>
            </div>
            <div className={classes.info}>
              <HourglassHalf className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="dureeFormation" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.duration} mois
              </div>
            </div>
            {info?.rythmAlternance && (
              <div className={classes.info}>
                <LoopIcon className={cx(global.infoIcon, classes.icon)} />
                <div className={cx(global.infoText, classes.text)}>
                  <FormattedMessage id="cycleAlternance" /> :{' '}
                </div>
                <div className={css({ marginLeft: spacing(1) })}>
                  {info?.rythmAlternance}
                </div>
              </div>
            )}
            <div className={classes.info}>
              <DateRange className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Dépot de candidature :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={info?.applicationStartDate}
                  year="numeric"
                />{' '}
                au{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={info?.applicationClosingDate}
                  year="numeric"
                />
              </div>
            </div>
          </Grid>
          <Grid item>
            <div className={classes.info}>
              <ListChecked className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="conditionAdmission" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.entryRequierement?.label}
              </div>
            </div>
            <div className={classes.info}>
              <GradeIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="reconaissanceDiplome" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.certifyingAuthority?.label === 'Etat'
                  ? 'Reconnu par l’état'
                  : 'Non reconnu par l’état'}
              </div>
            </div>
            <div className={classes.info}>
              <Home className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Présence :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.studyPlan?.label}
              </div>
            </div>
            <div className={classes.info}>
              <LanguageIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="langRequis" /> :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                {info?.workedLangage?.map(({ label }) => `${label} `)}
              </div>
            </div>
            <div className={classes.info}>
              <EventAvailable className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Prochaine rentrée :{' '}
              </div>
              <div className={css({ marginLeft: spacing(1) })}>
                <FormattedDate
                  day="numeric"
                  month="long"
                  value={info?.openingDate}
                  year="numeric"
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.textContainer}>
        <div className={cx(global.title, classes.title)}><p style={{ margin: 0 }}>Description:</p></div>
        {info?.description !== ' ' ? (
          <div className={classes.modifyLink}>{parse(info?.description)}</div>
        ) : (
          <div>Pas de description</div>
        )}
      </div>
      {profile === 'INDIVIDUAL' && (
        <div className={css({ marginTop: spacing(3) })}>
          <Grid container spacing={3}>
            <Grid item md={6} lg={5} xl={4}>
              {checkPostule ? (
                <Button
                  color="primary"
                  disabled
                  fullWidth
                  variant="contained"
                >
                  Déjà postulé
                </Button>
              ) : new Date(info?.applicationStartDate?.split('T')[0]) <= date &&
                new Date(info?.applicationClosingDate?.split('T')[0]) >=
                date ? (
                <Button
                  color="primary"
                  disabled={isLoadingPostuleTraining}
                  fullWidth
                  onClick={postuTraining}
                  variant="contained"
                >
                  Postuler
                </Button>
              ) : (
                <Button
                  color="primary"
                  disabled
                  fullWidth
                  startIcon={<Block />}
                  variant="contained"
                >
                  Formation fermée
                </Button>
              )}
            </Grid>
            <Grid item md={6} lg={5} xl={4}>
              {checkSave ? (
                <Button
                  disabled={isLoadingUnSavedTraining}
                  fullWidth
                  onClick={unSaveTraining}
                  startIcon={<Favorite color="primary" />}
                  variant="outlined"
                >
                  <FormattedMessage id="AddedToFavorite" />
                </Button>
              ) : (
                <Button
                  disabled={isLoadingSavedTraining}
                  fullWidth
                  onClick={saveTraining}
                  startIcon={<FavoriteBorder />}
                  variant="outlined"
                >
                  <FormattedMessage id="AddToFavorite" />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    background,
    color: '#152652',
  },
  icon: {
    color: '#0060F9',
  },
  text: {
    color: '#152652',
    fontWeight: 600,
  },
  title: {
    borderTop: '1px solid #C0D9FF',
    paddingTop: spacing(2.5),
    '& p': {
      borderLeft: '3px solid #0060F9',
      paddingLeft: spacing(1)
    },
  },
  textContainer: {
    '& > *': {
      textAlign: 'justify',
    },
  },
  info: {
    marginTop: spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  paddingTopMobile: {
    '@media screen and (max-width: 768px)': {
      paddingTop: '0 !important'
    }
  },
  paddingBottomMobile: {
    '@media screen and (max-width: 768px)': {
      paddingBottom: '0 !important'
    }
  }
});

DetailsFormation.propTypes = {
  info: PropTypes.object,
};

export default DetailsFormation;
